const state = {
  modal: {
    close: false
  }
}

const getters = {
  GET_MODAL(state) {
    return state.modal
  }
}

const mutations = {
  SET_CLOSE_MODAL(state) {
    state.modal.close = !state.modal.close;
  }
}

const actions = {
  TOGGLE_CLOSE_WINDOW(context) {
    context.commit('SET_CLOSE_MODAL')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
